<div class="contact-page sec-padding">
  <div class="mt-20 fx-row xs-fx-col fx-main-center fx-cross-center">
    <mat-card appearance="outlined" class="xs-fx-flex-50-in-col print-fx-flex-50 gt-xs-fx-flex-50">
      <div class="contact-form">
        <h3>Create an Account</h3>
        <form class="fx-row-wrap">
          <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
            <mat-form-field class="w-100 ds-validate">
              <mat-label>First Name</mat-label>
              <input matInput [(ngModel)]="userInfo.firstName"
                [ngModelOptions]="{standalone: true}" validate noempty="true">
            </mat-form-field>
          </div>
          <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
            <mat-form-field class="w-100 ds-validate">
              <mat-label>Last Name</mat-label>
              <input matInput [(ngModel)]="userInfo.lastName"
                [ngModelOptions]="{standalone: true}"  validate noempty="true">
            </mat-form-field>
          </div>
          <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
            <mat-form-field class="w-100 ds-validate">
              <mat-label>Your Email (required)</mat-label>
              <input matInput [(ngModel)]="userInfo.email"
                [ngModelOptions]="{standalone: true}"  validate noempty="true" email="true" (focusout)="validEmailData(userInfo.email);">
      
            </mat-form-field>
          </div>
          <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
            <mat-form-field class="w-100 ds-validate">
              <mat-label>User Name</mat-label>
              <input matInput [(ngModel)]="userInfo.username"
                [ngModelOptions]="{standalone: true}"  validate noempty="true" inputspace="true" validname="true" (paste)="$event.preventDefault()" (focusout)="verifyUsername(userInfo.username);">
             
            </mat-form-field>
          </div>
          <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
            <mat-form-field class="w-100 ds-validate">
              <mat-label>Password</mat-label>
              <input matInput type="password"  id="txtPassword" [(ngModel)]="userInfo.password"
                [ngModelOptions]="{standalone: true}"  validate noempty="true" regxvalid="true" zxcvbn="" regxvalidvalue="((?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{8,})" nospaceallow="true">
            </mat-form-field>
          </div>
          <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
            <mat-form-field class="w-100 ds-validate">
              <mat-label>Confirm Password</mat-label>
              <input matInput type="password" [(ngModel)]="userInfo.confirmpassword"
                [ngModelOptions]="{standalone: true}"  validate noempty="true" password-match="true" >
            </mat-form-field>
          </div>
          <div class="fx-row fx-flex-100">
            <div class="button-wrap">
              <button class="btn-project m-r-10" mat-raised-button color="primary" type="submit">{{'back' | translate}}</button>
            </div>
            <div class="button-wrap">
              <button class="btn-project m-l-0" mat-raised-button color="primary" validate trigger-check="true" (success)="createCustomer()">{{'create_' | translate}}</button>
            </div>
          </div>
          
        </form>
      </div>
    </mat-card>
  </div>
</div>

